import React, { useState, useEffect } from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import DropdownInput from 'components/Dropdown/Dropdown';

interface FilterOptionProps {
  data: any[];
  label: string;
  field: string;
  selectedValue: string[];
  onChange: Function;
  isVisible?: boolean;
}

const FilterOption = ({
  data,
  label,
  field,
  selectedValue = [],
  onChange
}: FilterOptionProps) => {
  const [selected, setSelected] = useState<string[]>(selectedValue);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (JSON.stringify(selected) !== JSON.stringify(selectedValue)) {
      setSelected(selectedValue);
    }
  }, [selectedValue]);

  const handleSelect = (option: string) => {
    if (option && !selected.includes(option)) {
      const newSelected = [...selected, option];
      setSelected(newSelected);
      onChange(field, newSelected);
      setValue(option);
    }
  };

  const handleRemove = (option: string) => {
    const newSelected = selected.filter(item => item !== option);
    setSelected(newSelected);
    onChange(field, newSelected);
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'top' }}
    >
      <div style={{ width: '100%' }}>
        <DropdownInput
          options={
            data &&
            data
              .filter(option => !!option)
              .map((option: any) => ({
                name: option?.name ? option.name : option, // Keep the correct structure
                value: option.value
              }))
          }
          label={`Select ${label}`}
          onChange={(e: any) => handleSelect(e.name)} // Update state on selection
          objectKey={'name'}
          search={true}
          value={value} // No single value, since it's a multi-select
          clearValue
        />

        {/* Dynamically render selected items */}
        {selected.length > 0 && (
          <div
            style={{
              display: 'inline-flex',
              gap: '.2rem',
              marginTop: '.5rem',
              flexWrap: 'wrap'
            }}
          >
            {selected.map(item => (
              <span
                key={item}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '.2rem',
                  padding: '.2rem .5rem',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  backgroundColor: '#f0f0f0'
                }}
              >
                {item}
                <CancelIcon
                  style={{ fontSize: '1rem', cursor: 'pointer' }}
                  onClick={() => handleRemove(item)} // Handle removal of selected item
                />
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterOption;
